module.exports = __webpack_public_path__ + "img/i_document.a0237bcf.svg";